<div [ngClass]="{'drag-menu-active':(svcMenuBase.svcMenuDrag.menuOpen | async), 'crud-menu-active':(svcMenuBase.svcMenuCrud.menuOpen | async)}" class="drag-menu drag-menu-fg">
	<div class="drag-menu-panels">
		<div class="table-btns">
			<div class="btn" (click)="svcAiData.getAsstCoaching()">
				<i class="absolute fa-sharp fal fa-circle"></i>
				<i class="absolute fa-sharp fal fa-circle animate-ping"></i>
			</div>
			<div class="btn right-0" (click)="svcMenuBase.svcMenuDrag.menuOpen.next(!(svcMenuBase.svcMenuDrag.menuOpen.getValue()))">
				<i class="fa-sharp fal fa-xmark-large"></i>
			</div>
			<div class="menu-btns" [ngClass]="{'menu-btns-active':(svcMenuBase.svcMenuDrag.menuOpen | async)}">
				@for (
						panel of svcMenuBase.svcMenuDrag.menuPanels; track panel.uuid) {
					<div class="tool-btn" [ngClass]="{'tool-btn-active':(svcMenuBase.svcMenuDrag.menuType | async) === panel.type}" (click)="svcMenuBase.menuDragToggle($index, panel.type)">
						{{panel.name}}
					</div>
				}
			</div>
		</div>
		<div class="drag-menu-panels-body" id="PanelWrapperDrag">
			@for (
					panel of svcMenuBase.svcMenuDrag.menuPanels; track panel.uuid) {
				<div class="drag-menu-panel">
					<ng-container class="block w-full h-full" [ngComponentOutlet]="panel.comp"></ng-container>
				</div>
			}
		</div>
	</div>
</div>

<div [ngClass]="{'drag-menu-active':(svcMenuBase.svcMenuDrag.menuOpen | async), 'crud-menu-active':(svcMenuBase.svcMenuCrud.menuOpen | async)}" class="drag-menu drag-menu-bg"></div>